export var generateGuid = function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/utils.js
// module id = 127
// module chunks = 0 1